import axios, { AxiosInstance } from 'axios';

import { AppEnv } from 'coreOld/enums';
import { APP_ENV, PHPSESSID } from 'global';

interface IParams {
  method: string;
  path: string;
  data?: unknown;
  options?: Record<string, unknown>;
  signal?: AbortSignal; // used for aborting previous pending requests
}

const GET = 'get';
const POST = 'post';
const PUT = 'put';
const PATCH = 'patch';
const DELETE = 'delete';

const METHODS_WITH_DATA = [POST, PUT, PATCH];

const apiClient: AxiosInstance = axios.create({
  baseURL: '',
  withCredentials: true,
});

export const get = (path: string, signal?: AbortSignal) => {
  return request({
    method: GET,
    path,
    signal,
  });
};

export const post = (
  path: string,
  data?: unknown,
  options?: Record<string, unknown>,
  signal?: AbortSignal
) => {
  return request({
    method: POST,
    path,
    data,
    options,
    signal,
  });
};

export const patch = (path: string, data: unknown) => {
  return request({
    method: PATCH,
    path,
    data,
  });
};

export const remove = (path: string, data?: unknown) => {
  return request({
    method: DELETE,
    path,
    data,
  });
};

export const request = async ({ method, path, data, options, signal }: IParams) => {
  const cookie = APP_ENV === AppEnv.DEVELOPMENT ? { phpsessid: PHPSESSID } : {};

  const config = {
    headers: {
      'x-requested-with': 'XMLHttpRequest',
      ...cookie,
      ...options,
    },
    signal,
  };

  if (METHODS_WITH_DATA.includes(method)) {
    return await apiClient[method](path, data, config);
  }

  if (DELETE === method && data) {
    return await apiClient[method](path, { data, ...config });
  }

  return await apiClient[method](path, config);
};

export const partfinitiClient = {
  get,
  post,
  patch,
  remove,
};
